import dayjs from 'dayjs';

/** PUBLIC_LEVEL 行程的公開權限等級
 * @description topics page 在 pc 上每 4 個為一組 index 序號為 0,8,16,32,64...為大版面,其他小版面，但是大版面還有分左右...故需要計算哪些是大版面，又是左還是右，哪些是小版面...
 */
export const PUBLIC_LEVEL = {
  /** @type {string} 私密：此時的行程無法透過連結分享他人、SEO 也不該爬到  */
  PRIVATE: '0',
  /** @type {string} 透過連結分享：此時的行程可以透過連結分享、但 SEO 還是不該爬到  */
  BY_LINK: '1',
  /** @type {string} 公開：此時的行程可以透過連結分享、SEO 也可以爬到  */
  PUBLIC: '2'
};

export const NEW_TRIP_DAYS_FROM_NOW = 3;

export const TRIP_PERMISSION = {
  READ: 0,
  EDIT: 1
};

export const EVENT_COPY_TRIP_PARAMS = {
  SOCIAL_TYPE: 2,
  DEFAULT_START_DATE: dayjs().startOf('D').add(1, 'month').format('YYYYMMDD')
};
